import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const NavButton = styled.div`
  border: none !important;
  border-radius: 0.5rem;
  background-color: ${(props) => (props.active ? props.$mainColor : '#fff')};
  color: ${(props) => (props.active ? props.$textColor : props.$mainColor)};
  padding: 0.5rem 1rem;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: ${(props) =>
      props.active ? props.$mainColor : props.$secondaryColor};
    color: ${(props) => (props.active ? props.$textColor : '#fff')};
  }
`;

/**
 * @typedef {Object} TabNavigationButtonProps
 * @property {string} title - O título do botão de navegação
 * @property {boolean} isActive - Estado que indica se a aba está ativa
 * @property {() => void} onClick - Função de callback executada ao clicar no botão
 * @property {string} [mainColor] - Cor principal opcional
 * @property {string} [secondaryColor] - Cor secundária opcional
 * @property {string} [textColor] - Cor do texto opcional
 */

export function TabNavigationButton({
  title,
  isActive,
  onClick,
  mainColor,
  secondaryColor,
  textColor,
  props
}) {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  return (
    <NavButton
      active={isActive}
      onClick={onClick}
      $mainColor={mainColor || systemConfiguration.primary_color}
      $secondaryColor={secondaryColor || systemConfiguration.secondary_color}
      $textColor={textColor || 'hsl(0, 0%, 100%)'}
      $borderRadius={systemConfiguration.border_radius}
      {...props}
    >
      {title}
    </NavButton>
  );
}
